import { DiscussionScreen } from '@/screens/index'

export default function () {
  return <DiscussionScreen />
}
